import {footerNav} from "@/utils/landingPageContent"; // Ensure correct import
import {t} from "i18next";
import React from "react";

const Footer = () => {
	return (
		<div className="singleWave">
			<footer className="-mt-10">
				<div
					className="bg-[#D26A53] flex flex-col md:flex-row items-center justify-between w-full overflow-hidden py-[2vh] px-[2vw] text-white text-center md:text-left"
				>
					<div className="flex flex-col items-start">
						<address className="flex flex-col font-custom-regular space-y-1">
							<span>{t("HOME_PAGE.FOOTER.EMAIL")}</span>
							<a href="mailto:info@joglekarkul.com">info@joglekarkul.com</a>
							<a href="mailto:support@joglekarkul.com">support@joglekarkul.com</a>
							<a href="mailto:feedback@joglekarkul.com">feedback@joglekarkul.com</a>
						</address>
					</div>

					<div className="flex justify-center space-x-6 md:space-x-10 p-1 mt-5">
						{footerNav.social.map((item) => (
							<a
								key={item.name}
								href={item.href}
								target={"_blank"}
								className="text-blue-800 hover:text-white"
							>
								<img src={item.icon} alt={item.name} className="h-10 w-10"/>
								<span className="sr-only">{item.name}</span>
							</a>
						))}
					</div>
				</div>
				<div
					className="bg-white flex flex-col md:flex-row justify-center items-center w-full overflow-hidden py-[2vh] px-[2vw] text-black text-center md:text-left"
				>
					<img
						className="h-[1.5vw] w-auto px-[1vw]"
						src="/landing/powered_by_csi.png"
						alt="Powered by CS Infocomm"
					/>
				</div>
			</footer>
		</div>
	);
};

export default Footer;
